import { cn } from '@/lib/utils'

interface UserAvatarProps {
  initials: string
  className?: string
  style?: React.CSSProperties
}

export function UserAvatar({ initials, className, style }: UserAvatarProps) {
  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center rounded-200 text-ui-header-h4 leading-ui-header-h4 font-semibold uppercase bg-main-support-surface-cyan text-main-support-on-surface-on-cyan',
        className,
      )}
      style={style}
    >
      {initials}
    </div>
  )
}
